import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { Block } from 'app/interfaces/blocks';
import { Subscription } from 'rxjs';
import { EventHandlersService } from '../../edit-template/event-handler.service';

interface IPageBreakSettingDTO {
  uuid: string
}

@Component({
  selector: 'app-page-break-settings',
  templateUrl: './page-break-settings.component.html',
  styleUrl: './page-break-settings.component.scss'
})
export class PageBreakSettingsComponent implements OnChanges {
  @Input() data: IPageBreakSettingDTO;
  public timeOutSubscription: Subscription;
  public pageBreakData: Block;

  constructor(
    private eventHandlersService: EventHandlersService,
    private globalService: GlobalService
  ) { }

  /**
     * listen the changes whenever call the component
     * @param changes 
     */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.updateSettings();
    }
  }

  updateSettings() {
    this.pageBreakData = this.globalService.fields_data['blocks'][this.data['uuid']];
  }

  /** Close external right menu */
  close() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }
}
